import script from "./StatusYearTotal.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatusYearTotal.vue?vue&type=script&setup=true&lang=ts"

import "./StatusYearTotal.vue?vue&type=style&index=0&id=a93aa85a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a93aa85a"]])

export default __exports__